// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file truck_service.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { DriverOnShift, DriverOnShiftJson } from "./driver_on_shift_pb";
import { file_driver_on_shift } from "./driver_on_shift_pb";
import type { JobType, JobTypeJson, TruckStatus, TruckStatusJson, TruckType, TruckTypeJson } from "./enums_pb";
import { file_enums } from "./enums_pb";
import type { DateTimeFilter, DateTimeFilterJson, ListFilter, ListFilterJson, ListInfo, ListInfoJson, MessageResponseSchema } from "./general_pb";
import { file_general } from "./general_pb";
import type { StructJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct } from "@bufbuild/protobuf/wkt";
import type { GpsStopListSchema } from "./gps_tables_pb";
import { file_gps_tables } from "./gps_tables_pb";
import type { Route, RouteJson } from "./route_pb";
import { file_route } from "./route_pb";
import type { CustomTruckTypeCreateSchema, CustomTruckTypeListSchema, CustomTruckTypeSchema, CustomTruckTypeUpdateSchema, SearchTruckRequestSchema, SearchTruckResponseSchema, Truck, TruckCreateSchema, TruckJson, TruckPositionListSchema, TruckSchema, TruckUpdateSchema } from "./truck_pb";
import { file_truck } from "./truck_pb";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file truck_service.proto.
 */
export const file_truck_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_driver_on_shift, file_enums, file_general, file_google_protobuf_struct, file_gps_tables, file_route, file_truck]);

/**
 * @generated from message raccoonai.TruckListRequest
 */
export type TruckListRequest = Message<"raccoonai.TruckListRequest"> & {
  /**
   * filter by org
   *
   * @generated from field: repeated uint64 owner_organization_ids = 1 [json_name = "owner_organization_ids"];
   */
  ownerOrganizationIds: bigint[];

  /**
   * filter by truck type
   *
   * @generated from field: repeated raccoonai.TruckType types = 2 [json_name = "type"];
   */
  types: TruckType[];

  /**
   * filter by custom truck type
   *
   * @generated from field: repeated uint64 truck_type_ids = 3 [json_name = "custom_truck_type_ids"];
   */
  truckTypeIds: bigint[];

  /**
   * filter by job types
   *
   * @generated from field: repeated raccoonai.JobType job_types = 4 [json_name = "job_types"];
   */
  jobTypes: JobType[];

  /**
   * filter by container types (for trucks with specific container compatibility)
   *
   * @generated from field: repeated uint64 container_type_ids = 5 [json_name = "container_type_ids"];
   */
  containerTypeIds: bigint[];

  /**
   * filter by truck status
   *
   * @generated from field: repeated raccoonai.TruckStatus statuses = 6;
   */
  statuses: TruckStatus[];

  /**
   * shift_zone_ids: trucks those organizations own or that carry a shift of theirs (its zone), starting within
   * shift_datetime_filter, or running now without it. Each id needs driver_on_shift view.
   *
   * @generated from field: repeated uint64 shift_zone_ids = 7 [json_name = "shift_zone_ids"];
   */
  shiftZoneIds: bigint[];

  /**
   * @generated from field: optional raccoonai.DateTimeFilter shift_datetime_filter = 8 [json_name = "shift_datetime_filter"];
   */
  shiftDatetimeFilter?: DateTimeFilter;

  /**
   * @generated from field: optional raccoonai.ListFilter list_filter = 10 [json_name = "list_filter"];
   */
  listFilter?: ListFilter;
};

/**
 * @generated from message raccoonai.TruckListRequest
 */
export type TruckListRequestJson = {
  /**
   * filter by org
   *
   * @generated from field: repeated uint64 owner_organization_ids = 1 [json_name = "owner_organization_ids"];
   */
  owner_organization_ids?: string[];

  /**
   * filter by truck type
   *
   * @generated from field: repeated raccoonai.TruckType types = 2 [json_name = "type"];
   */
  type?: TruckTypeJson[];

  /**
   * filter by custom truck type
   *
   * @generated from field: repeated uint64 truck_type_ids = 3 [json_name = "custom_truck_type_ids"];
   */
  custom_truck_type_ids?: string[];

  /**
   * filter by job types
   *
   * @generated from field: repeated raccoonai.JobType job_types = 4 [json_name = "job_types"];
   */
  job_types?: JobTypeJson[];

  /**
   * filter by container types (for trucks with specific container compatibility)
   *
   * @generated from field: repeated uint64 container_type_ids = 5 [json_name = "container_type_ids"];
   */
  container_type_ids?: string[];

  /**
   * filter by truck status
   *
   * @generated from field: repeated raccoonai.TruckStatus statuses = 6;
   */
  statuses?: TruckStatusJson[];

  /**
   * shift_zone_ids: trucks those organizations own or that carry a shift of theirs (its zone), starting within
   * shift_datetime_filter, or running now without it. Each id needs driver_on_shift view.
   *
   * @generated from field: repeated uint64 shift_zone_ids = 7 [json_name = "shift_zone_ids"];
   */
  shift_zone_ids?: string[];

  /**
   * @generated from field: optional raccoonai.DateTimeFilter shift_datetime_filter = 8 [json_name = "shift_datetime_filter"];
   */
  shift_datetime_filter?: DateTimeFilterJson;

  /**
   * @generated from field: optional raccoonai.ListFilter list_filter = 10 [json_name = "list_filter"];
   */
  list_filter?: ListFilterJson;
};

/**
 * Describes the message raccoonai.TruckListRequest.
 * Use `create(TruckListRequestSchema)` to create a new message.
 */
export const TruckListRequestSchema: GenMessage<TruckListRequest, {jsonType: TruckListRequestJson}> = /*@__PURE__*/
  messageDesc(file_truck_service, 0);

/**
 * @generated from message raccoonai.TruckList
 */
export type TruckList = Message<"raccoonai.TruckList"> & {
  /**
   * @generated from field: repeated raccoonai.Truck trucks = 1;
   */
  trucks: Truck[];

  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 2 [json_name = "list_info"];
   */
  listInfo?: ListInfo;
};

/**
 * @generated from message raccoonai.TruckList
 */
export type TruckListJson = {
  /**
   * @generated from field: repeated raccoonai.Truck trucks = 1;
   */
  trucks?: TruckJson[];

  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 2 [json_name = "list_info"];
   */
  list_info?: ListInfoJson;
};

/**
 * Describes the message raccoonai.TruckList.
 * Use `create(TruckListSchema)` to create a new message.
 */
export const TruckListSchema: GenMessage<TruckList, {jsonType: TruckListJson}> = /*@__PURE__*/
  messageDesc(file_truck_service, 1);

/**
 * @generated from message raccoonai.CompatibleTrucksForPlgRequest
 */
export type CompatibleTrucksForPlgRequest = Message<"raccoonai.CompatibleTrucksForPlgRequest"> & {
  /**
   * @generated from field: required uint64 pickup_location_group_id = 1 [json_name = "pickup_location_group_id"];
   */
  pickupLocationGroupId: bigint;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;
};

/**
 * @generated from message raccoonai.CompatibleTrucksForPlgRequest
 */
export type CompatibleTrucksForPlgRequestJson = {
  /**
   * @generated from field: required uint64 pickup_location_group_id = 1 [json_name = "pickup_location_group_id"];
   */
  pickup_location_group_id?: string;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;
};

/**
 * Describes the message raccoonai.CompatibleTrucksForPlgRequest.
 * Use `create(CompatibleTrucksForPlgRequestSchema)` to create a new message.
 */
export const CompatibleTrucksForPlgRequestSchema: GenMessage<CompatibleTrucksForPlgRequest, {jsonType: CompatibleTrucksForPlgRequestJson}> = /*@__PURE__*/
  messageDesc(file_truck_service, 2);

/**
 * @generated from message raccoonai.CreateGuestTruckRequest
 */
export type CreateGuestTruckRequest = Message<"raccoonai.CreateGuestTruckRequest"> & {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: required string plate_number = 2 [json_name = "plate_number"];
   */
  plateNumber: string;

  /**
   * @generated from field: required raccoonai.TruckType type = 3;
   */
  type: TruckType;
};

/**
 * @generated from message raccoonai.CreateGuestTruckRequest
 */
export type CreateGuestTruckRequestJson = {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: required string plate_number = 2 [json_name = "plate_number"];
   */
  plate_number?: string;

  /**
   * @generated from field: required raccoonai.TruckType type = 3;
   */
  type?: TruckTypeJson;
};

/**
 * Describes the message raccoonai.CreateGuestTruckRequest.
 * Use `create(CreateGuestTruckRequestSchema)` to create a new message.
 */
export const CreateGuestTruckRequestSchema: GenMessage<CreateGuestTruckRequest, {jsonType: CreateGuestTruckRequestJson}> = /*@__PURE__*/
  messageDesc(file_truck_service, 3);

/**
 * @generated from message raccoonai.TruckWeightRequest
 */
export type TruckWeightRequest = Message<"raccoonai.TruckWeightRequest"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required double truck_weight = 2 [json_name = "truck_weight"];
   */
  truckWeight: number;
};

/**
 * @generated from message raccoonai.TruckWeightRequest
 */
export type TruckWeightRequestJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required double truck_weight = 2 [json_name = "truck_weight"];
   */
  truck_weight?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message raccoonai.TruckWeightRequest.
 * Use `create(TruckWeightRequestSchema)` to create a new message.
 */
export const TruckWeightRequestSchema: GenMessage<TruckWeightRequest, {jsonType: TruckWeightRequestJson}> = /*@__PURE__*/
  messageDesc(file_truck_service, 4);

/**
 * @generated from message raccoonai.CustomTruckTypeListRequest
 */
export type CustomTruckTypeListRequest = Message<"raccoonai.CustomTruckTypeListRequest"> & {
  /**
   * @generated from field: repeated uint64 owner_organization_ids = 1 [json_name = "owner_organization_ids"];
   */
  ownerOrganizationIds: bigint[];

  /**
   * filter by truck type
   *
   * @generated from field: repeated raccoonai.TruckType types = 2 [json_name = "type"];
   */
  types: TruckType[];

  /**
   * filter by job types
   *
   * @generated from field: repeated raccoonai.JobType job_types = 3 [json_name = "job_types"];
   */
  jobTypes: JobType[];

  /**
   * filter by container types
   *
   * @generated from field: repeated uint64 container_type_ids = 5 [json_name = "container_type_ids"];
   */
  containerTypeIds: bigint[];

  /**
   * @generated from field: optional raccoonai.ListFilter list_filter = 10 [json_name = "list_filter"];
   */
  listFilter?: ListFilter;
};

/**
 * @generated from message raccoonai.CustomTruckTypeListRequest
 */
export type CustomTruckTypeListRequestJson = {
  /**
   * @generated from field: repeated uint64 owner_organization_ids = 1 [json_name = "owner_organization_ids"];
   */
  owner_organization_ids?: string[];

  /**
   * filter by truck type
   *
   * @generated from field: repeated raccoonai.TruckType types = 2 [json_name = "type"];
   */
  type?: TruckTypeJson[];

  /**
   * filter by job types
   *
   * @generated from field: repeated raccoonai.JobType job_types = 3 [json_name = "job_types"];
   */
  job_types?: JobTypeJson[];

  /**
   * filter by container types
   *
   * @generated from field: repeated uint64 container_type_ids = 5 [json_name = "container_type_ids"];
   */
  container_type_ids?: string[];

  /**
   * @generated from field: optional raccoonai.ListFilter list_filter = 10 [json_name = "list_filter"];
   */
  list_filter?: ListFilterJson;
};

/**
 * Describes the message raccoonai.CustomTruckTypeListRequest.
 * Use `create(CustomTruckTypeListRequestSchema)` to create a new message.
 */
export const CustomTruckTypeListRequestSchema: GenMessage<CustomTruckTypeListRequest, {jsonType: CustomTruckTypeListRequestJson}> = /*@__PURE__*/
  messageDesc(file_truck_service, 5);

/**
 * @generated from message raccoonai.CurrentTruckStatus
 */
export type CurrentTruckStatus = Message<"raccoonai.CurrentTruckStatus"> & {
  /**
   * @generated from field: required raccoonai.Truck truck = 1;
   */
  truck?: Truck;

  /**
   * @generated from field: optional raccoonai.DriverOnShift current_shift = 2 [json_name = "current_shift"];
   */
  currentShift?: DriverOnShift;

  /**
   * @generated from field: optional raccoonai.DriverOnShift latest_shift = 3 [json_name = "latest_shift"];
   */
  latestShift?: DriverOnShift;

  /**
   * @generated from field: optional raccoonai.Route current_route = 4 [json_name = "current_route"];
   */
  currentRoute?: Route;
};

/**
 * @generated from message raccoonai.CurrentTruckStatus
 */
export type CurrentTruckStatusJson = {
  /**
   * @generated from field: required raccoonai.Truck truck = 1;
   */
  truck?: TruckJson;

  /**
   * @generated from field: optional raccoonai.DriverOnShift current_shift = 2 [json_name = "current_shift"];
   */
  current_shift?: DriverOnShiftJson;

  /**
   * @generated from field: optional raccoonai.DriverOnShift latest_shift = 3 [json_name = "latest_shift"];
   */
  latest_shift?: DriverOnShiftJson;

  /**
   * @generated from field: optional raccoonai.Route current_route = 4 [json_name = "current_route"];
   */
  current_route?: RouteJson;
};

/**
 * Describes the message raccoonai.CurrentTruckStatus.
 * Use `create(CurrentTruckStatusSchema)` to create a new message.
 */
export const CurrentTruckStatusSchema: GenMessage<CurrentTruckStatus, {jsonType: CurrentTruckStatusJson}> = /*@__PURE__*/
  messageDesc(file_truck_service, 6);

/**
 * @generated from message raccoonai.CurrentTruckStatusList
 */
export type CurrentTruckStatusList = Message<"raccoonai.CurrentTruckStatusList"> & {
  /**
   * @generated from field: repeated raccoonai.CurrentTruckStatus truck_statuses = 1 [json_name = "truck_statuses"];
   */
  truckStatuses: CurrentTruckStatus[];

  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 2 [json_name = "list_info"];
   */
  listInfo?: ListInfo;
};

/**
 * @generated from message raccoonai.CurrentTruckStatusList
 */
export type CurrentTruckStatusListJson = {
  /**
   * @generated from field: repeated raccoonai.CurrentTruckStatus truck_statuses = 1 [json_name = "truck_statuses"];
   */
  truck_statuses?: CurrentTruckStatusJson[];

  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 2 [json_name = "list_info"];
   */
  list_info?: ListInfoJson;
};

/**
 * Describes the message raccoonai.CurrentTruckStatusList.
 * Use `create(CurrentTruckStatusListSchema)` to create a new message.
 */
export const CurrentTruckStatusListSchema: GenMessage<CurrentTruckStatusList, {jsonType: CurrentTruckStatusListJson}> = /*@__PURE__*/
  messageDesc(file_truck_service, 7);

/**
 * @generated from message raccoonai.TruckRequest
 */
export type TruckRequest = Message<"raccoonai.TruckRequest"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;
};

/**
 * @generated from message raccoonai.TruckRequest
 */
export type TruckRequestJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;
};

/**
 * Describes the message raccoonai.TruckRequest.
 * Use `create(TruckRequestSchema)` to create a new message.
 */
export const TruckRequestSchema: GenMessage<TruckRequest, {jsonType: TruckRequestJson}> = /*@__PURE__*/
  messageDesc(file_truck_service, 8);

/**
 * @generated from message raccoonai.TruckTypeRequest
 */
export type TruckTypeRequest = Message<"raccoonai.TruckTypeRequest"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;
};

/**
 * @generated from message raccoonai.TruckTypeRequest
 */
export type TruckTypeRequestJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;
};

/**
 * Describes the message raccoonai.TruckTypeRequest.
 * Use `create(TruckTypeRequestSchema)` to create a new message.
 */
export const TruckTypeRequestSchema: GenMessage<TruckTypeRequest, {jsonType: TruckTypeRequestJson}> = /*@__PURE__*/
  messageDesc(file_truck_service, 9);

/**
 * @generated from message raccoonai.TruckTravelPathRequest
 */
export type TruckTravelPathRequest = Message<"raccoonai.TruckTravelPathRequest"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: required raccoonai.DateTimeFilter from_to = 3 [json_name = "from_to"];
   */
  fromTo?: DateTimeFilter;
};

/**
 * @generated from message raccoonai.TruckTravelPathRequest
 */
export type TruckTravelPathRequestJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: required raccoonai.DateTimeFilter from_to = 3 [json_name = "from_to"];
   */
  from_to?: DateTimeFilterJson;
};

/**
 * Describes the message raccoonai.TruckTravelPathRequest.
 * Use `create(TruckTravelPathRequestSchema)` to create a new message.
 */
export const TruckTravelPathRequestSchema: GenMessage<TruckTravelPathRequest, {jsonType: TruckTravelPathRequestJson}> = /*@__PURE__*/
  messageDesc(file_truck_service, 10);

/**
 * @generated from message raccoonai.TruckTravelPathResponse
 */
export type TruckTravelPathResponse = Message<"raccoonai.TruckTravelPathResponse"> & {
  /**
   * @generated from field: required uint64 truck_id = 1 [json_name = "truck_id"];
   */
  truckId: bigint;

  /**
   * @generated from field: required google.protobuf.Struct geojson_feature = 2 [json_name = "geojson_feature"];
   */
  geojsonFeature?: JsonObject;
};

/**
 * @generated from message raccoonai.TruckTravelPathResponse
 */
export type TruckTravelPathResponseJson = {
  /**
   * @generated from field: required uint64 truck_id = 1 [json_name = "truck_id"];
   */
  truck_id?: string;

  /**
   * @generated from field: required google.protobuf.Struct geojson_feature = 2 [json_name = "geojson_feature"];
   */
  geojson_feature?: StructJson;
};

/**
 * Describes the message raccoonai.TruckTravelPathResponse.
 * Use `create(TruckTravelPathResponseSchema)` to create a new message.
 */
export const TruckTravelPathResponseSchema: GenMessage<TruckTravelPathResponse, {jsonType: TruckTravelPathResponseJson}> = /*@__PURE__*/
  messageDesc(file_truck_service, 11);

/**
 * @generated from message raccoonai.TruckGpsStopsRequest
 */
export type TruckGpsStopsRequest = Message<"raccoonai.TruckGpsStopsRequest"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: required raccoonai.DateTimeFilter from_to = 3 [json_name = "from_to"];
   */
  fromTo?: DateTimeFilter;

  /**
   * Stops the detectors could not tie to a known site (stop_type UNKNOWN /
   * NO_NEARBY_PL) are the bulk of the rows and are noise on most maps, so they
   * are opt-in. Verification screens set this to surface "stopped near, but not
   * at, the container".
   *
   * @generated from field: optional bool include_unmatched = 4 [json_name = "include_unmatched"];
   */
  includeUnmatched: boolean;
};

/**
 * @generated from message raccoonai.TruckGpsStopsRequest
 */
export type TruckGpsStopsRequestJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: required raccoonai.DateTimeFilter from_to = 3 [json_name = "from_to"];
   */
  from_to?: DateTimeFilterJson;

  /**
   * Stops the detectors could not tie to a known site (stop_type UNKNOWN /
   * NO_NEARBY_PL) are the bulk of the rows and are noise on most maps, so they
   * are opt-in. Verification screens set this to surface "stopped near, but not
   * at, the container".
   *
   * @generated from field: optional bool include_unmatched = 4 [json_name = "include_unmatched"];
   */
  include_unmatched?: boolean;
};

/**
 * Describes the message raccoonai.TruckGpsStopsRequest.
 * Use `create(TruckGpsStopsRequestSchema)` to create a new message.
 */
export const TruckGpsStopsRequestSchema: GenMessage<TruckGpsStopsRequest, {jsonType: TruckGpsStopsRequestJson}> = /*@__PURE__*/
  messageDesc(file_truck_service, 12);

/**
 * @generated from message raccoonai.DeviceMappingListRequest
 */
export type DeviceMappingListRequest = Message<"raccoonai.DeviceMappingListRequest"> & {
  /**
   * Matches external_mapping.external_source (e.g. "wialon_ips").
   *
   * @generated from field: required string external_source = 1 [json_name = "external_source"];
   */
  externalSource: string;
};

/**
 * @generated from message raccoonai.DeviceMappingListRequest
 */
export type DeviceMappingListRequestJson = {
  /**
   * Matches external_mapping.external_source (e.g. "wialon_ips").
   *
   * @generated from field: required string external_source = 1 [json_name = "external_source"];
   */
  external_source?: string;
};

/**
 * Describes the message raccoonai.DeviceMappingListRequest.
 * Use `create(DeviceMappingListRequestSchema)` to create a new message.
 */
export const DeviceMappingListRequestSchema: GenMessage<DeviceMappingListRequest, {jsonType: DeviceMappingListRequestJson}> = /*@__PURE__*/
  messageDesc(file_truck_service, 13);

/**
 * @generated from message raccoonai.DeviceMapping
 */
export type DeviceMapping = Message<"raccoonai.DeviceMapping"> & {
  /**
   * Matches external_mapping.external_id — a device identifier such as a tracker IMEI.
   *
   * @generated from field: required string external_id = 1 [json_name = "external_id"];
   */
  externalId: string;

  /**
   * @generated from field: required uint64 truck_id = 2 [json_name = "truck_id"];
   */
  truckId: bigint;

  /**
   * @generated from field: required uint64 owner_organization_id = 3 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;
};

/**
 * @generated from message raccoonai.DeviceMapping
 */
export type DeviceMappingJson = {
  /**
   * Matches external_mapping.external_id — a device identifier such as a tracker IMEI.
   *
   * @generated from field: required string external_id = 1 [json_name = "external_id"];
   */
  external_id?: string;

  /**
   * @generated from field: required uint64 truck_id = 2 [json_name = "truck_id"];
   */
  truck_id?: string;

  /**
   * @generated from field: required uint64 owner_organization_id = 3 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;
};

/**
 * Describes the message raccoonai.DeviceMapping.
 * Use `create(DeviceMappingSchema)` to create a new message.
 */
export const DeviceMappingSchema: GenMessage<DeviceMapping, {jsonType: DeviceMappingJson}> = /*@__PURE__*/
  messageDesc(file_truck_service, 14);

/**
 * @generated from message raccoonai.DeviceMappingList
 */
export type DeviceMappingList = Message<"raccoonai.DeviceMappingList"> & {
  /**
   * @generated from field: repeated raccoonai.DeviceMapping device_mappings = 1 [json_name = "device_mappings"];
   */
  deviceMappings: DeviceMapping[];
};

/**
 * @generated from message raccoonai.DeviceMappingList
 */
export type DeviceMappingListJson = {
  /**
   * @generated from field: repeated raccoonai.DeviceMapping device_mappings = 1 [json_name = "device_mappings"];
   */
  device_mappings?: DeviceMappingJson[];
};

/**
 * Describes the message raccoonai.DeviceMappingList.
 * Use `create(DeviceMappingListSchema)` to create a new message.
 */
export const DeviceMappingListSchema: GenMessage<DeviceMappingList, {jsonType: DeviceMappingListJson}> = /*@__PURE__*/
  messageDesc(file_truck_service, 15);

/**
 * @generated from service raccoonai.TruckService
 */
export const TruckService: GenService<{
  /**
   * @generated from rpc raccoonai.TruckService.SearchTruck
   */
  searchTruck: {
    methodKind: "unary";
    input: typeof SearchTruckRequestSchema;
    output: typeof SearchTruckResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.TruckService.ListTrucks
   */
  listTrucks: {
    methodKind: "unary";
    input: typeof TruckListRequestSchema;
    output: typeof TruckListSchema;
  },
  /**
   * Trucks whose capability matrix covers every bound (container type, job type)
   * link of the pickup location group.
   *
   * @generated from rpc raccoonai.TruckService.ListCompatibleTrucksForPickupLocationGroup
   */
  listCompatibleTrucksForPickupLocationGroup: {
    methodKind: "unary";
    input: typeof CompatibleTrucksForPlgRequestSchema;
    output: typeof TruckListSchema;
  },
  /**
   * @generated from rpc raccoonai.TruckService.CreateGuestTruck
   */
  createGuestTruck: {
    methodKind: "unary";
    input: typeof CreateGuestTruckRequestSchema;
    output: typeof TruckSchema;
  },
  /**
   * @generated from rpc raccoonai.TruckService.UpdateTruckWeight
   */
  updateTruckWeight: {
    methodKind: "unary";
    input: typeof TruckWeightRequestSchema;
    output: typeof TruckSchema;
  },
  /**
   * @generated from rpc raccoonai.TruckService.CreateTruck
   */
  createTruck: {
    methodKind: "unary";
    input: typeof TruckCreateSchema;
    output: typeof TruckSchema;
  },
  /**
   * @generated from rpc raccoonai.TruckService.UpdateTruck
   */
  updateTruck: {
    methodKind: "unary";
    input: typeof TruckUpdateSchema;
    output: typeof TruckSchema;
  },
  /**
   * @generated from rpc raccoonai.TruckService.GetTruckById
   */
  getTruckById: {
    methodKind: "unary";
    input: typeof TruckRequestSchema;
    output: typeof TruckSchema;
  },
  /**
   * @generated from rpc raccoonai.TruckService.DeleteTruckById
   */
  deleteTruckById: {
    methodKind: "unary";
    input: typeof TruckRequestSchema;
    output: typeof MessageResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.TruckService.AllTruckStatuses
   */
  allTruckStatuses: {
    methodKind: "unary";
    input: typeof TruckListRequestSchema;
    output: typeof CurrentTruckStatusListSchema;
  },
  /**
   * @generated from rpc raccoonai.TruckService.CreateTruckType
   */
  createTruckType: {
    methodKind: "unary";
    input: typeof CustomTruckTypeCreateSchema;
    output: typeof CustomTruckTypeSchema;
  },
  /**
   * @generated from rpc raccoonai.TruckService.GetTruckTypeById
   */
  getTruckTypeById: {
    methodKind: "unary";
    input: typeof TruckTypeRequestSchema;
    output: typeof CustomTruckTypeSchema;
  },
  /**
   * @generated from rpc raccoonai.TruckService.UpdateTruckType
   */
  updateTruckType: {
    methodKind: "unary";
    input: typeof CustomTruckTypeUpdateSchema;
    output: typeof CustomTruckTypeSchema;
  },
  /**
   * @generated from rpc raccoonai.TruckService.DeleteTruckType
   */
  deleteTruckType: {
    methodKind: "unary";
    input: typeof TruckTypeRequestSchema;
    output: typeof MessageResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.TruckService.ListTruckTypes
   */
  listTruckTypes: {
    methodKind: "unary";
    input: typeof CustomTruckTypeListRequestSchema;
    output: typeof CustomTruckTypeListSchema;
  },
  /**
   * @generated from rpc raccoonai.TruckService.GetTruckTravelPath
   */
  getTruckTravelPath: {
    methodKind: "unary";
    input: typeof TruckTravelPathRequestSchema;
    output: typeof TruckTravelPathResponseSchema;
  },
  /**
   * Aggregated dwell events derived from the raw GPS stream, for overlaying on
   * top of the GetTruckTravelPath line.
   *
   * @generated from rpc raccoonai.TruckService.GetTruckGpsStops
   */
  getTruckGpsStops: {
    methodKind: "unary";
    input: typeof TruckGpsStopsRequestSchema;
    output: typeof GpsStopListSchema;
  },
  /**
   * @generated from rpc raccoonai.TruckService.GetTruckListLatestPositions
   */
  getTruckListLatestPositions: {
    methodKind: "unary";
    input: typeof TruckListRequestSchema;
    output: typeof TruckPositionListSchema;
  },
  /**
   * Cross-organization device -> truck resolution for system callers (e.g. GPSDataService's
   * IPS listener), sourced from external_mapping. Not organization-scoped by design: a
   * device's owning organization is part of what the caller is resolving.
   *
   * @generated from rpc raccoonai.TruckService.ListDeviceMappings
   */
  listDeviceMappings: {
    methodKind: "unary";
    input: typeof DeviceMappingListRequestSchema;
    output: typeof DeviceMappingListSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_truck_service, 0);

